export const enterpriseSearchVectorStores = [
    {value: "krtrimaIQ", label: "KrtrimaIQ"},
    {value: "Oup", label: "Oup"},
    {value: "external", label: "External Sources"},
];

export const dbSelect = [
    // {
    //     code: "DVD Store",
    //     text: "DVD Store", 
    // }
    {label: 'DVD Store', value: 'DVD Store'}
];

export const englishClassTypes = [
    {label: 'Primary (I-V)', value: 'primary'},
    {label: 'Middle School (VI-VIII)', value: 'middle'},
];

export const tRoles = [
    {label: 'Teacher', value: 'Teacher'},
    {label: 'Student', value: 'Student'}
];

export const llm = {
    'OpenAI':[
        // {code: "gpt3_turbo", text: "GPT-3.5 turbo"},
        // {code: "gpt3_turbo_16k", text: "GPT-3.5 Turbo 16k"},
        // {code: "gpt4", text: "GPT-4"},
        // {code: "gpt4_128k", text: "GPT-4 Turbo"},
        {code: "gpt-4o-mini", text: "GPT-4o Mini"},
        {code: "gpt4o", text: "GPT-4o"},
        
    ],
    'Anthropic':[
        {code: "claude_opus", text: "Claude Opus"},
        {code: "claude_sonnet", text: "Claude Sonnet"},
        {code: "claude_haiku", text: "Claude Haiku"},
    ]
};

export const organisation = [
    {code: "OpenAI_GPT", text: "OpenAI"},
    // {code: "Anthropic_Claude", text: "Anthropic"},
];
